import React, { useState } from 'react';
import css from './ContactUsPage.module.css';
import Footer from '../../components/Footer/Footer';
import TopbarContainer from '../TopbarContainer/TopbarContainer';
import {
  LayoutSingleColumn,
  LayoutWrapperFooter,
  LayoutWrapperMain,
  LayoutWrapperTopbar,
  Page,
} from '../../components';
import ContactUsForm from '../../components/ContactUsForm/ContactUsForm';
import { injectIntl } from 'react-intl';
import { defaultPhonecodeCountry } from '../../marketplace-custom-config';
import { isScrollingDisabled } from '../../ducks/UI.duck';
import { compose } from 'redux';
import { connect } from 'react-redux';
import config from '../../config';
import { apiBaseUrl } from '../../util/api';
import axios from '../../util/axiosHelper';
import { withRouter } from 'react-router-dom';

function ContactUsPage(props) {
  const { intl, scrollingDisabled, history } = props;
  const [step, setStep] = useState(0);
  const [submitDetails, setSubmitDetails] = useState({ inProgress: false, submitErr: null });
  const handleSubmit = values => {
    const { email, message, phoneNumber = {} } = values;
    const { iso2, iso3, dialCode, number } = phoneNumber;
    const hasValidData = !!email && !!message && !!iso2 && !!iso3 && !!dialCode && !!number;
    if (!hasValidData) return;
    setSubmitDetails({ inProgress: true, submitErr: null });
    const url = `${apiBaseUrl()}/api/contactus`;
    axios
      .post(url, { email, message, phoneNumber: { iso2, iso3, dialCode, number } })
      .then(_ => {
        setSubmitDetails(preDetails => ({ ...preDetails, inProgress: false }));
        setStep(1);
      })
      .catch(err => {
        setSubmitDetails({
          inProgress: false,
          submitErr: 'ContactUsForm.contactDetailsSaveFailed',
        });
      });
  };

  const siteTitle = config.siteTitle;
  const schemaTitle = intl.formatMessage({ id: 'LandingPage.schemaTitle' }, { siteTitle });

  return (
    <Page
      title={schemaTitle}
      scrollingDisabled={scrollingDisabled}
      schema={{
        '@context': 'http://schema.org',
        '@type': 'WebPage',
        name: schemaTitle,
      }}
    >
      <LayoutSingleColumn>
        <LayoutWrapperTopbar>
          <TopbarContainer />
        </LayoutWrapperTopbar>

        <LayoutWrapperMain className={css.layoutWrapperMain}>
          <ContactUsForm
            onSubmit={handleSubmit}
            intl={intl}
            step={step}
            history={history}
            initialValues={{
              phoneNumber: defaultPhonecodeCountry,
            }}
            {...submitDetails}
          />
        </LayoutWrapperMain>

        <LayoutWrapperFooter>
          <Footer />
        </LayoutWrapperFooter>
      </LayoutSingleColumn>
    </Page>
  );
}

const mapStateToProps = state => {
  return { scrollingDisabled: isScrollingDisabled(state) };
};

export default compose(
  connect(
    mapStateToProps,
    null
  ),
  injectIntl,
  withRouter
)(ContactUsPage);
